<template>
  <div>
    <div style="padding-bottom: 0.4rem" v-if="attachmentList.length == 0 && readonly">无</div>
    <div v-else>
      <van-uploader
        :max-count="readonly ? attachmentList.length : 3"
        :after-read="afterRead"
        v-model="fileList"
        @delete="deletePic"
        :before-read="beforeRead"
        :deletable="!readonly"
        accept=".png, .jpg, .jpeg, .gif, .bmp"
      >
        <img class="upload-icon" src="../../../assets/icon_upload.png"/>

      </van-uploader>
    </div>
  </div>
</template>

<script>
import { uploadFile } from "../../../api/HttpRequestAPI";
import {toast, showLoading, dismissLoading} from '../../../utils'
export default {
  name: "upload_view",
  components: {},
  props: {
    value: {
      type: Array,
      default: ()=>[]
    },
    businessType: {
      type: String,
      default: ''
    },
    readonly:{
      type:Boolean,
      default:false,
    }
  },
  data() {
    return {
      fileList: [],
      attachmentList: []
    };
  },
  computed: {},
  watch: {
    value(attachmentList) {
      console.log('attachmentList', JSON.stringify(attachmentList))
      if(attachmentList.length > 0) {
        this.attachmentList = attachmentList;
        this.fileList = attachmentList.map((data)=>{
          return{
            url:data.fileUrl
          }
        })
      } else {
        this.attachmentList = []
        this.fileList = []
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    //上传附件
    afterRead(file) {
      file.status = "uploading";
      file.message = "上传中...";
      this.reduceImg(file);
    },
    //压缩图片
    reduceImg(file) {
      console.log(file, "开始");
      // 大于2.5MB的jpeg和png图片都缩小像素上传
      if (/\/(?:jpeg|png)/i.test(file.file.type) && file.file.size > 14000) {
        // 创建Canvas对象(画布)
        let canvas = document.createElement("canvas");
        // 获取对应的CanvasRenderingContext2D对象(画笔)
        let context = canvas.getContext("2d");
        // 创建新的图片对象
        let img = new Image();
        // 指定图片的DataURL(图片的base64编码数据)
        img.src = file.content;
        // 监听浏览器加载图片完成，然后进行进行绘制
        img.onload = () => {
          // 指定canvas画布大小，该大小为最后生成图片的大小
          canvas.width = 348;
          canvas.height = 546;
          /* drawImage画布绘制的方法。(0,0)表示以Canvas画布左上角为起点，400，300是将图片按给定的像素进行缩小。
            如果不指定缩小的像素图片将以图片原始大小进行绘制，图片像素如果大于画布将会从左上角开始按画布大小部分绘制图片，最后的图片就是张局部图。*/

          context.drawImage(img, 0, 0, 348, 546);
          // 将绘制完成的图片重新转化为base64编码，file.file.type为图片类型，0.92为默认压缩质量
          file.content = canvas.toDataURL(file.file.type, 0.92);
          let files = this.dataURLtoFile(file.content, file.file.name);
          console.log(files, "结束");
          let formData = new FormData();
          formData.append("file", files);
          this.upload(formData, file);
        };
      } else {
        let formData = new FormData();
        formData.append("file", file.file);
        this.upload(formData, file);
      }
    },
    deletePic(file) {
      let attachmentList = this.attachmentList;
      if(file.url) {
        attachmentList.map((p, ind) => {
          if (p.fileUrl == file.url) {
            this.attachmentList.splice(ind, 1);
          }
        });
      } else {
        let delName = "";
        delName = file.file.name;

        let attachmentList = this.attachmentList;
        attachmentList.map((p, ind) => {
          if (p.originalName == delName) {
            this.attachmentList.splice(ind, 1);
          }
        });
      }
      this.$emit("input", attachmentList);
    },
    dataURLtoFile(dataurl, filename) {
      // 将base64转换为file文件
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    beforeRead(file) {
      let types = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/gif",
        "image/bmp"
      ];
      const isImage = types.includes(file.type);
      if (!isImage) {
        toast("请上传图片!");
        return false;
      }
      return true;
    },
    upload(files, file) {
      uploadFile(
        files,
        resp => {
          let name = resp.result.originalName;
          let url = resp.result.fileUrl;
          this.attachmentList.push({
            fileUrl: url,
            originalName: name
          });
          this.$emit("input", this.attachmentList);
          toast("附件上传成功");
          file.status = "done";
        },
        fail => {
          file.status = "failed";
          toast("附件上传失败");
        }
      );
    },
    getData(){
        return this.attachmentList
    },
    setData(attachmentList){
      if(attachmentList) {
        this.attachmentList = attachmentList;
        this.fileList = attachmentList.map((data)=>{
          return{
            url:data.fileUrl
          }
        })
      }
    }
  }
};
</script>
<style lang="less" scoped>
  /deep/ .van-uploader__preview-image{
    width: 105px;
    height: 105px;
    margin-right: 5px;
  }
  .upload-icon{
    width: 105px;
    height: 105px;
    margin-right: 5px;
  }
</style>
